<template>
  <v-container class="pt-0">
    <v-navigation-drawer app permanent expand-on-hover dark>
      <v-list v-if="isLogged">
        <v-list-item link to="/perfil" style="margin-left: -1em">
          <v-list-item class="px-2" v-if="user.avatar != null">
            <v-list-item-avatar>
              <v-img :src="user.avatar"></v-img>
            </v-list-item-avatar>
          </v-list-item>

          <v-list-item class="px-2" v-else>
            <v-avatar color="primary" size="40">
              <span class="white--text headline">{{
                user.name.substr(0, 1)
              }}</span>
            </v-avatar>
          </v-list-item>

          <v-list-item style="margin-left: -1em">
            <v-list-item-content class="py-0">
              <v-list-item-title class="title">
                {{ user.name }}
              </v-list-item-title>
              <v-list-item-subtitle>{{ user.email }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list-item>
      </v-list>

      <v-list v-else nav dense>
        <v-list-item link to="/login">
          <v-list-item-icon>
            <v-icon>mdi-login</v-icon>
          </v-list-item-icon>
          <v-list-item-title> Acceder </v-list-item-title>
        </v-list-item>
      </v-list>

      <v-divider></v-divider>

      <v-list nav dense>
        <div v-for="(link, i) in links" v-bind:key="i">
          <v-list-item
            v-if="!link.subLinks"
            :key="i"
            :to="link.to"
            class="v-list-item"
          >
            <v-list-item-icon>
              <v-icon>{{ link.icon }}</v-icon>
            </v-list-item-icon>

            <v-list-item-title>{{ link.text }}</v-list-item-title>
          </v-list-item>

          <v-list-group v-else :key="link.text" no-action>
            <template v-slot:activator>
              <v-list-item>
                <v-list-item-icon style="margin-left: -0.5em">
                  <v-icon>{{ link.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-title>{{ link.text }}</v-list-item-title>
              </v-list-item>
            </template>

            <v-list-item
              v-for="sublink in link.subLinks"
              :to="sublink.to"
              :key="sublink.text"
            >
              <v-list-item-title>{{ sublink.text }}</v-list-item-title>
            </v-list-item>
          </v-list-group>
        </div>
      </v-list>

      <v-divider></v-divider>

      <v-list-group no-action :key="themeUpdated">
        <template v-slot:activator>
          <v-list-item dense>
            <v-list-item-icon style="margin-left: -1em">
              <v-icon>mdi-palette</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Temas / Colores</v-list-item-title>
          </v-list-item>
        </template>

        <v-list-item
          dense
          v-for="(theme, index) in themes"
          :key="index"
          :disabled="$vuetify.theme.themes.name === theme.name"
          @click="setTheme(theme)"
        >
          <v-list-item-title>{{ theme.name }}</v-list-item-title>
        </v-list-item>

        <v-list-item dense>
          <v-list-item-content
            ><v-list-item-title class="font-weight-bold">
              Modo Oscuro</v-list-item-title
            >
          </v-list-item-content>
          <v-list-item-action @click="themeUpdated = !themeUpdated"
            ><v-switch v-model="$vuetify.theme.dark" />
          </v-list-item-action>
        </v-list-item>
      </v-list-group>
    </v-navigation-drawer>
  </v-container>
</template>

<script>
export default {
  name: "MenuBar",

  props: {
    isLogged: Boolean,
    user: Object,
    links: Array,
    title: String,
  },

  computed: {
    selectedTheme() {
      return this.$vuetify.theme.themes.name;
    },
  },

  data: () => ({
    themeUpdated: false,
    themes: [
      {
        name: "Predeterminada",
        dark: {
          primary: "#1269BE",
          secondary: "#777777",
          accent: "#458BFF",
          info: "#0076D5",
          success: "#28912C",
          warning: "#E8B20E",
          error: "#D82D2D",
        },
        light: {
          primary: "#1976D2",
          secondary: "#999999",
          accent: "#82B1FF",
          info: "#2196F3",
          success: "#4CAF50",
          warning: "#FFC107",
          error: "#FF5252",
        },
      },
      {
        name: "Combinación 1",
        dark: {
          primary: "#21CFF3",
          secondary: "#21dc79",
          accent: "#FF4081",
          info: "#f34fc6",
          success: "#86af3f",
          warning: "#FB8C00",
          error: "#FF5252",
        },
        light: {
          primary: "#22daff",
          secondary: "#26ff8c",
          accent: "#ff6b99",
          info: "#ff53d0",
          success: "#a5d64c",
          warning: "#ff8e00",
          error: "#ff5252",
        },
      },
      {
        name: "Combinación 2",
        dark: {
          primary: "#E65100",
          secondary: "#689F38",
          accent: "#7CB342",
          info: "#6156d8",
          success: "#4CAF50",
          warning: "#1565C0",
          error: "#FF7043",
        },
        light: {
          primary: "#ffa450",
          secondary: "#92de4e",
          accent: "#a1e754",
          info: "#7365ff",
          success: "#6dff74",
          warning: "#2e8ac0",
          error: "#ff5e3c",
        },
      },
      {
        name: "Combinación 3",
        dark: {
          primary: "#33691E",
          secondary: "#607D8B",
          accent: "#FFCA28",
          info: "#2196F3",
          success: "#FFEB3B",
          warning: "#9C27B0",
          error: "#B71C1C",
        },
        light: {
          primary: "#6ae240",
          secondary: "#7ea4b6",
          accent: "#ffe063",
          info: "#229eff",
          success: "#ffea70",
          warning: "#e239ff",
          error: "#e82424",
        },
      },
    ],
  }),

  methods: {
    logout() {
      this.$emit("event");
    },

    setTheme(theme) {
      // close menu
      const name = theme.name;
      const dark = theme.dark;
      const light = theme.light;
      // set themes
      Object.keys(dark).forEach((i) => {
        this.$vuetify.theme.themes.dark[i] = dark[i];
      });
      Object.keys(light).forEach((i) => {
        this.$vuetify.theme.themes.light[i] = light[i];
      });
      // also save theme name to disable selection
      this.$vuetify.theme.themes.name = name;
      // para que redibuje el elemento
      this.themeUpdated = !this.themeUpdated;
    },
  },

  mounted() {
    this.setTheme(this.themes[0]);
  },
};
</script>
